<template>
  <div class="bg">
    <div :style="{background:dynamicColor.rgb}" class="bacColor">
      <img alt="" src="../../../static/images/bgrule2.png">
    </div>
    <div class="returnBut" @click="returnBut">
      <img alt="" src="../../../static/images/return_b.png">
      <p>返回</p>
    </div>
    <div class="information">
      需求建议
    </div>
    <div class="wrapCon">
      <div class="">
        <el-input
          v-model="textarea"
          :rows="10"
          maxlength="800"
          placeholder="请输入10字以上的需求描述或建议反馈"
          show-word-limit
          type="textarea"
        ></el-input>
        <div class="submit">
          <el-button :style="{background:dynamicColor.rgb}" size="medium" type="primary" @click="submit">
            提交
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Toast} from "vant";
import cookie from "js-cookie";
var mobile = cookie.get("xq-mobile");
var appid = cookie.get("xq-appid");

export default {
  name: "index",
  data() {
    return {
      tabStat: 0,
      textarea: "",
      dynamicColor: {},
    }
  },
  created(e) {
    this.dynamicColor = JSON.parse(localStorage.getItem('bakColor'));
  },
  methods: {
    tab(e) {
      this.tabStat = e;
    },
    returnBut() {
      this.$router.replace('/' );
    },
    /**
     * 提交
     */
    submit() {
      if (this.textarea.length < 10) {
        Toast.fail("请输入不少于10字");
        return false
      }
      var apiName = this.API1url.API;
      this.$post(apiName.aveOrUpdate, {
        appid: appid,
        mobile: mobile,
        content: this.textarea
      }).then((res) => {
        if (res.code == '0000') {
          Toast.success("提交成功");
          setTimeout(() => {
            this.returnBut()
          }, 1500)
        } else {
          Toast.fail(res.msg);
        }
      });
    }
  }
}
</script>
<style>

.wrapCon .el-textarea__inner {
  border: none;
  border-bottom: 1px solid #e7e7e7;
}

</style>
<style scoped>
.bg {
  width: 100%;
  height: 100vh;
  position: relative;
  /*left: 0;*/
  /*top: 0;*/
  /*right: 0;*/
  /*bottom: 0;*/
  /*background: ;*/
  /*background-size: 100% 100%;*/
  overflow-y: scroll;
}

.bacColor {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 668px;
  /*z-index: -1;*/
}

.bacColor > img {
  width: 100%;
  height: 100%;
}

.information {
  display: flex;
  font-size: 28px;
  /*font-weight: bold;*/
  color: #ffffff;
  margin: 68px 0 76px 32px;
  position: relative;
  z-index: 1;
}

.wrapCon {
  width: 93%;
  background: #FFFFFF;
  margin: 24px auto;
  overflow: hidden;
  position: relative;
  z-index: 1;
}


.submit {
  padding: 250px 20px 30px;
}

.submit .el-button {
  border: none;
  width: 100%;
}


.returnBut {
  position: absolute;
  left: 20px;
  top: 16px;
  z-index: 99;
  display: flex;
  align-items: center;
}

.returnBut > img {
  width: 20px;
  height: 18px;
}

.returnBut > p {
  color: #ffffff;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/suggest/index.vue